export default __webpack_public_path__ + "media/zurb/img/ecommerce/loyalty_2-99a52f9d7b56fd4641f4b1f9d59fdba3.png";